// styles
import styled, { css } from 'styled-components';
// components
import { CloseIcon, GirdedInfoIcon } from 'refactored/ui/icons';
import { useSelector } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';
import config from 'config';
import { useMemo } from 'react';
const ModalOverlay = styled.div`
  /* border: 5px solid green; */
  position: absolute;
  /* height: 200px; */
  /* width: 400px, */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: pink;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  background: #26334096;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;

  ${(props) =>
    props.isVisible &&
    css`
      opacity: 1;
      pointer-events: all;
    `}
`;
const ModalContainer = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 12px;

  width: 680px;
  /* height: 200px; */
  max-height: 600px;
  overflow: auto;
  margin-bottom: 20%;

  /* secondary / white */

  background: #ffffff;
  /* grey / 300 */

  border: 1px solid #ccd6e0;
  border-radius: 8px;
  /* border: 5px solid cyan; */
  z-index: 1;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;

  height: 32px;

  /* border: 1px solid red; */
  width: 100%;
`;

const HeaderTitle = styled.div`
  height: 32px;

  /* 24px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  /* secondary / black */

  color: #1c1c1c;
`;
const HeaderCloseIcon = styled.div`
  width: 16px;
  height: 16px;

  /* grey / 500 */

  /* background: #94a6b8; */
  cursor: pointer;
  svg {
    fill: #94a6b8;
  }
`;
const BodyContainer = styled.div`
  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;

  width: 100%;
`;

const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  /* border: 1px solid red; */
  width: 100%;
`;

const Column = styled.div`
  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;

  /* width: 316px; */
  /* flex-grow: 1; */
  width: 50%;

  background: #ffffff;
  /* grey / 200 */

  border: 1px solid #e2e8ee;
  border-radius: 8px;
  /* border: 5px solid green; */
`;

const ColumnHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  height: 24px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height, or 120% */

  /* grey / 700 */

  color: #54708c;
  /* border: 1px solid black; */
`;

const ColumnText = styled.div`
  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  /* grey / 700 */

  color: #54708c;
  /* border: 1px solid black; */
  ul {
    margin: 0;
    padding-left: 32px;
  }
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 16px;

  width: 648px;
  height: 108px;

  /* grey / 100 */

  background: #f2f5f8;
  /* grey / 200 */

  border: 1px solid #e2e8ee;
  border-radius: 8px;
  /* border: 5px solid red; */
`;

const InfoIconContainer = styled.div`
  width: 20px;
  height: 20px;
  /* border: 5px solid black; */
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  width: 100%;
  height: 48px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
`;

const InfoInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;

  width: 100%;
  height: 76px;
  /* border: 5px solid cyan; */
  svg path {
    fill: #2ac787;
  }
`;

const InfoText = styled.div`
  width: 100%;
  height: 24px;

  /* 16px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 700 */

  color: #54708c;
  a {
    color: var(--primary500);
  }
`;

const CoverageModal = ({ showModal, setShowModal }) => {
  const country = useSelector(settingsSelectors.getCountry);
  const secondaryLink = useMemo(() => config.OFFER_LINKS[country], [country]);
  return (
    <ModalOverlay isVisible={showModal}>
      <ModalContainer>
        <HeaderContainer>
          <HeaderTitle>Área de cobertura</HeaderTitle>
          <HeaderCloseIcon onClick={() => setShowModal(false)}>
            <CloseIcon />
          </HeaderCloseIcon>
        </HeaderContainer>
        <BodyContainer>
          <ColumnsContainer>
            <Column>
              <ColumnHeader>Cobertura regional</ColumnHeader>
              <ColumnText>
                <ul>
                  <li>Comunidad de madrid </li>
                  <li>Cataluña </li>
                  <li>Comunidad Valenciana </li>
                  <li>País Vasco y Pamplona</li>
                </ul>
              </ColumnText>
            </Column>
            <Column>
              <ColumnHeader>Cobertura nacional</ColumnHeader>
              <ColumnText>
                <ul>
                  <li>
                    Recogida en Cataluña, entrega en cualquier punto de España y
                    viceversa.
                  </li>
                </ul>
              </ColumnText>
            </Column>
          </ColumnsContainer>
          <InfoContainer>
            <InfoInnerContainer>
              <InfoIconContainer>
                <GirdedInfoIcon />
              </InfoIconContainer>
              <TextContainer>
                <InfoText>
                  Puedes ver más información sobre{' '}
                  <a target="_blank" href={secondaryLink} rel="noreferrer">
                    nuestra área de cobertura aquí.
                  </a>
                </InfoText>
              </TextContainer>
            </InfoInnerContainer>
          </InfoContainer>
        </BodyContainer>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default styled(CoverageModal)``;
